export const tokenTemp = "sK1iBP7iB773B19sii7-AgPaPrAsGeEsUsCoPxPwAtFiStMkDsQuBiPoFeRe";
export const BASEURL = 'https://socialmedx.azurewebsites.net/';//https://rock.medx.med.br/
export const URLIMG = 'https://medxdata.blob.core.windows.net/medxsocial/'; //'https://socialmedx.azurewebsites.net/';
export const BASEURL2 = 'https://rock.medx.med.br/' //'https://socialmedx.azurewebsites.net/';//
